import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { truncateText } from "@forgepoint/shared";
import { BodyRenderer } from "./BodyRenderer";

const PREVIEW_LENGTH = 150;

export const UserMessageViewer = ({
  message,
  messageType,
  messageLabel,
}: {
  message: string;
  messageType?: string;
  messageLabel?: string | null;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const body = message;

  if (body.length === 0) {
    return null;
  }

  const bodyPreview = truncateText(body, PREVIEW_LENGTH);
  const hasLongBody = body.length > PREVIEW_LENGTH;
  const header = messageLabel ?? messageType ?? "User Message";
  const displayedBody = isExpanded ? body : bodyPreview;
  const canToggle = hasLongBody;
  const buttonText = isExpanded ? "Hide message" : "View full message";
  const ButtonIcon = isExpanded ? ChevronDown : ChevronRight;

  return (
    <div className="border rounded-md p-3 bg-muted/30 space-y-3 text-xs">
      <div>
        <span className="font-semibold">Type:</span>{" "}
        <span className="text-muted-foreground">{header}</span>
      </div>
      <div className="pt-2 border-t">
        <BodyRenderer body={displayedBody} />
      </div>
      {canToggle && (
        <div className="pt-2 border-t">
          <Button
            variant="ghost"
            size="sm"
            className="h-7 text-xs p-0 hover:bg-transparent"
            onClick={() => setIsExpanded((current) => !current)}
          >
            <ButtonIcon className="h-3 w-3 mr-1" />
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};
